import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationDurationPluginService } from './duration.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalComponent } from '../../../modal/modal.component';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-duration-edit',
    templateUrl: './duration-edit.component.html',
    standalone: false
})
export class InstallationDurationEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  timeUnits: any[];

  private sub = new Subscription();

  @ViewChild('unitsModal', { static: true }) unitsModal: ModalComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationDurationPluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateDuration(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.controls['units'].markAsTouched();
  }

  public openTimeUnitsSelector() {
    this.openSelector(this.unitsModal, this.timeUnits, this.editForm.controls.units.value);
  }

  public selectTimeUnitsMenu(item: any) {
    const selectedIndex = this.editForm.controls.units.value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls.units.setValue(selectedIndex);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.timeUnits = this.pluginService.getTimeUnits();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      label: new UntypedFormControl(this.plugin.config.Duration?.Label ?? ''),
      durationValue: new UntypedFormControl(
        this.plugin.config.Duration?.DurationValue ? parseInt(this.plugin.config.Duration.DurationValue) : ''
      ),
      units: new UntypedFormControl(
        this.plugin.config.Duration?.Units ? parseInt(this.plugin.config.Duration.Units) : ''
      )
    });
  }
}
